<template>
  <form class="form" v-if="!isLoading">
    <div class="form_cell">
      <div class="row_center_center label_title">
        <label for="name">Line暱稱</label>
        <text class="must">(必填)</text>
      </div>
      <input
        type="text"
        name="name"
        placeholder="請輸入暱稱"
        v-model="formData.name"
      />
    </div>

    <div class="form_cell">
      <div class="row_center_center label_title">
        <label for="birthday">生日</label>
      </div>
      <div
        style="
          height: 46px;
          width: 100%;
          font-size: 16px;
          border: 1px solid #dddddd;
          border-radius: 6px;
        "
      >
        <el-date-picker
          size="default"
          :disabled="memberInfo.birthday ? true : false"
          v-model="formData.birthday"
          type="date"
          placeholder="請選擇生日"
          :editable="false"
        ></el-date-picker>
      </div>
    </div>

    <div class="form_cell">
      <div class="row_center_center label_title">
        <label for="gender">性別</label>
      </div>
      <div class="gender_cell">
        <input
          type="button"
          class="gender_button"
          v-for="(item, index) in genders"
          :key="index"
          :value="item.gender"
          :class="{ selected: genderSelectedIndex === index }"
          @click="selectGender(index)"
        />
      </div>
    </div>

    <div class="form_cell">
      <div class="row_center_center label_title">
        <label for="name">電子信箱</label>
      </div>
      <input
        type="email"
        name="email"
        placeholder="請輸入電子信箱"
        v-model="formData.email"
      />
    </div>

    <div class="form_cell">
      <div class="row_center_center label_title">
        <label for="name">手機門號</label>
        <text class="must">(必填)</text>
      </div>
      <input
        type="tel"
        name="phone"
        inputmode="tel"
        placeholder="請輸入手機門號"
        v-model="formData.mobile_phone"
        maxlength="10"
      />
    </div>

    <div class="form_cell">
      <div class="row_center_center label_title">
        <label for="address"
          >常用地址
          <text
            :style="{
              color: formData.addresses.length == 2 ? '#C0462E' : '#000000',
            }"
            >({{ formData.addresses.length }}/2)</text
          >
        </label>
      </div>

      <div class="column_center_start invoce_setting">
        <div
          class="row_center_start"
          v-if="getDefaultAddressData.is_default === 1"
          style="
            width: 100%;
            font-weight: 500;
            border-bottom: 1px dotted #aaaaaa;
            padding-bottom: 10px;
            flex-shrink: 0;
          "
        >
          <text style="color: #fd5001; width: 100%; word-wrap: break-word">
            (預設)
            <span style="color: #000; width: 100%">
              {{ getDefaultAddressData.postcode }}
              {{ getCityName(getDefaultAddressData.city_id) }}
              {{ getCityAreaName(getDefaultAddressData.cityarea_id) }}
              {{ getDefaultAddressData.address }}
            </span>
          </text>
        </div>
        <div
          v-else
          class="row_center_center"
          style="
            width: 100%;
            font-size: 18px;
            font-weight: 500;
            border-bottom: 1px dotted #aaaaaa;
            padding-bottom: 10px;
          "
        >
          尚未設定預設地址
        </div>
        <div
          v-for="(addressData, addressIndex) in formData.addresses"
          :key="addressIndex"
          class="column_start_start address"
        >
          {{ addressData.postcode }}{{ getCityName(addressData.city_id)
          }}{{ getCityAreaName(addressData.cityarea_id)
          }}{{ addressData.address }}
          <div class="row_center_between" style="width: 100%; padding: 10px 0">
            <!-- <button v-if="addressData.type == 1" class="row_center_center address_type">通訊</button>
            <button v-if="addressData.type == 2" class="row_center_center address_type">收件</button>
            <button v-if="addressData.type == 3" class="row_center_center address_type">發票</button> -->
            <div class="row_center_end" style="flex-grow: 1">
              <button
                class="row_center_center address_button"
                style="color: #c0462e"
                @click="showDeleteAddressPopup(addressIndex)"
              >
                刪除
              </button>
              <button
                class="row_center_center address_button"
                @click="editAddresss(addressIndex)"
              >
                編輯
              </button>
              <button
                class="row_center_center address_button"
                v-if="addressData.is_default !== 1"
                @click="setDefaultAddress(addressIndex)"
              >
                設為預設
              </button>
            </div>
          </div>
        </div>
        <button
          class="row_center_center add_address title"
          @click="addNewAddress"
        >
          新增地址
        </button>
      </div>
    </div>

    <div
      class="row_start_start label_title"
      style="width: 100%; margin-bottom: 10px"
    >
      <label for="company_tax_number">發票設定</label>
    </div>
    <div class="column_center_start invoce_setting">
      <div class="form_cell">
        <div class="row_center_center label_title">
          <label for="company_tax_number">統一編號</label>
        </div>
        <input
          type="text"
          name="company_tax_number"
          maxlength="8"
          inputmode="numeric"
          placeholder="請輸入統一編號"
          v-model="formData.s_vat_number"
        />
      </div>

      <div class="form_cell">
        <div class="row_center_center label_title">
          <label for="barcode_id">手機載具</label>
        </div>
        <input
          type="text"
          name="barcode_id"
          placeholder="請輸入手機載具"
          v-model="formData.invoice_carrier"
          maxlength="8"
          oninput="this.value=this.value.toUpperCase()"
        />
      </div>

      <div class="form_cell">
        <div class="row_center_center label_title">
          <label for="love_code">愛心碼</label>
        </div>
        <input
          type="text"
          name="love_code"
          inputmode="numeric"
          placeholder="請輸入愛心碼"
          v-model="formData.npo_ban"
          maxlength="7"
        />
      </div>
    </div>

    <input type="button" class="button" @click="submitForm" value="儲存" />
    <ModifyAddress
      v-if="showModifyAddress"
      @confirm="saveAddress"
      @close="closeModifyAddressPopup"
    ></ModifyAddress>
    <popup @confirm="popupConfirm" @cancel="popupCancel" ref="popup"></popup>
  </form>
</template>
<script>
import commonUtilities from "@/utils/common.utils";
import auth from "@/utils/auth.utils";
import Swal from "sweetalert2";
import modifyAddress from "@/components/memberInfo/modifyAddress.vue";
import popup from "@/components/general/popup.vue";
import moment from "moment";
import "moment/locale/zh-tw";
import { checkEinvoiceCode } from "@/services/api.service";
import {
  getEinvoiceErrorMessage,
  getEinvoiceErrorData,
  shouldValidateEinvoiceCode,
  isSilentPassCode,
} from "@/utils/einvoice.utils";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    ModifyAddress: modifyAddress,
    popup: popup,
  },
  data() {
    return {
      formData: {},
      genders: [
        {
          gender: "男性",
          id: 1,
        },
        {
          gender: "女性",
          id: 2,
        },
        {
          gender: "其他",
          id: 3,
        },
      ],
      genderSelectedIndex: 0,
      isLoading: true,
      showModifyAddress: false,
    };
  },
  computed: {
    ...mapState("userData", {
      getToken: "token",
      memberInfo: "memberInfo",
    }),
    ...mapGetters("userData", {
      isLogin: "isLogin",
      storeCode: "storeCode",
    }),
    ...mapState("basic", {
      selectedAddressData: "selectedAddressData",
      cities: "cities",
      cityAreas: "cityAreas",
    }),
    getDefaultAddressData() {
      const addresses = this.formData.addresses;
      if (!addresses.length) {
        return {};
      }
      for (const address of addresses) {
        if (address.is_default === 1) {
          return address;
        }
      }
      return {};
    },
    // 店家發票服務商類型
    invoiceProviderType() {
      return (
        this.$store.getters["basic/activeStoreInfo"]?.invoice_provider_type ??
        null
      );
    },
    // 是否需要呼叫驗證 API（僅光貿店家）
    shouldValidateWithApi() {
      return shouldValidateEinvoiceCode(this.invoiceProviderType);
    },
  },
  async mounted() {
    try {
      // 顯示讀loading 彈窗
      commonUtilities.createLoading("資料讀取中", "請稍後");
      this.initialize();
    } catch (error) {
      this.isLoading = false;
      console.log(error);
    }
  },
  watch: {
    isLoading(state) {
      if (!state) {
        Swal.clickCancel();
      }
    },
    "formData.birthday"(newValue) {
      let birthday = moment(newValue).format("YYYY-MM-DD");
      if (birthday == "Invalid date") birthday = null;
      this.formData.birthday = birthday;
    },
  },
  methods: {
    popupConfirm(e) {
      e();
    },
    popupCancel(e) {
      e();
    },
    async initialize() {
      try {
        if (!this.isLogin) throw "token expired";
        await this.$store.dispatch("basic/fetchCities");
        await this.$store.dispatch("basic/fetchCityAreas");
        // load latest member info
        await this.$store.dispatch("userData/fetchMemberInfo");
        this.genderSelectedIndex = this.memberInfo.gender - 1;
        this.formData = structuredClone(this.memberInfo);

        // 統編欄位向後相容：如果 s_vat_number 為 null，使用 vat_number 的值
        if (!this.formData.s_vat_number && this.formData.vat_number) {
          this.formData.s_vat_number = this.formData.vat_number;
        }
      } catch (error) {
        this.isLoading = false;
        commonUtilities.createToast("warning", "登入狀態已過期，請重新登入");
        auth.logout();
        this.$router.push({
          path: `/${this.storeCode}`,
        });
        console.log(error);
        return;
      } finally {
        this.isLoading = false;
      }
    },
    getCityName(cityId) {
      const city = this.cities.find((city) => {
        return city.id == cityId;
      });
      return city?.name ? city.name : "";
    },
    getCityAreaName(cityAreaId) {
      const cityArea = this.cityAreas.find((cityArea) => {
        return cityArea.id == cityAreaId;
      });
      return cityArea?.name ? cityArea.name : "";
    },
    selectGender(index) {
      this.genderSelectedIndex = index;
      this.formData.gender = this.genders[index].id;
    },
    async showDeleteAddressPopup(index) {
      event.preventDefault();
      let addressData = { ...this.formData.addresses[index] };
      addressData.cityName = this.getCityName(addressData.city_id);
      addressData.cityAreaName = this.getCityAreaName(addressData.cityarea_id);
      this.$store.commit("basic/setSelectedAddressData", addressData);
      this.$refs.popup.show({
        title: `確定要刪除此地址嗎？`,
        content: `${addressData.postcode}${addressData.cityName}${addressData.cityAreaName}${addressData.address}`,
        confirmEvent: this.confirmAddressDelete,
        cancelEvent: this.denyAddressDelete,
      });
    },
    async confirmAddressDelete() {
      try {
        const addressData = this.selectedAddressData;
        this.isLoading = true;
        commonUtilities.createLoading("資料更新中", "請稍後");
        const sendData = {
          address_id: [addressData.id.toString()],
        };
        await this.$store.dispatch("userData/deleteAddress", sendData);
        this.showDeleteAddress = false;
        this.$store.commit("basic/setSelectedAddressData", null);

        // 重新載入資料
        await this.initialize();

        // 檢查是否需要設定新的預設地址
        if (this.formData.addresses && this.formData.addresses.length > 0) {
          // 檢查是否有預設地址
          const hasDefaultAddress = this.formData.addresses.some(
            (addr) => addr.is_default === 1
          );

          if (!hasDefaultAddress) {
            // 如果沒有預設地址，將第一個地址設為預設
            console.log("刪除預設地址後，自動將第一個地址設為預設");
            const addresses = JSON.parse(
              JSON.stringify(this.formData.addresses)
            );
            addresses[0].is_default = 1;
            this.formData.addresses = addresses;

            // 更新到後端
            await this.$store.dispatch("userData/updateMemberInfo", {
              addresses: this.formData.addresses,
            });
            await this.initialize();
          }
        }

        this.isLoading = false;
        commonUtilities.createToast("success", "刪除成功");
      } catch (error) {
        this.showDeleteAddress = false;
        this.$store.commit("basic/setSelectedAddressData", null);
        await this.initialize();
        this.isLoading = false;
        commonUtilities.createToast("error", error?.message || String(error));
        console.log("刪除地址錯誤: ", error);
      }
    },
    denyAddressDelete() {
      this.showDeleteAddress = false;
      this.$store.commit("basic/setSelectedAddressData", null);
      commonUtilities.createToast("info", "已取消刪除");
    },
    editAddresss(index) {
      event.preventDefault();
      // 開啟編輯地址彈窗
      const addressData = {
        data: {
          ...this.formData.addresses[index],
        },
        index: index,
      };
      this.$store.commit("basic/setSelectedAddressData", addressData);
      this.showModifyAddress = true;
    },
    closeModifyAddressPopup() {
      event.preventDefault();
      this.$store.commit("basic/setSelectedAddressData", null);
      this.showModifyAddress = false;
    },
    setDefaultAddress(index) {
      event.preventDefault();
      let addresses = JSON.parse(JSON.stringify(this.formData.addresses));
      addresses.forEach((address) => {
        address.is_default = 0;
      });
      addresses[index].is_default = 1;
      this.formData.addresses = addresses;
    },
    addNewAddress() {
      event.preventDefault();
      if (this.formData.addresses.length >= 2) {
        commonUtilities.createToast("error", "最多只能新增 2 個地址");
        return;
      }
      // 開啟新增地址彈窗
      this.$store.commit("basic/setSelectedAddressData", null);
      this.showModifyAddress = true;
    },
    saveAddress() {
      event.preventDefault();
      // 關閉彈窗
      this.showModifyAddress = false;
      // 取得彈窗資料
      let addressData = this.selectedAddressData;
      const addresses = JSON.parse(JSON.stringify(this.formData.addresses));

      if (addressData.index != null) {
        // 編輯地址
        console.log("編輯地址資料", addressData);
        addresses[addressData.index] = addressData.data;
      } else {
        // 新增地址

        // 如果目前沒有任何地址，設定為預設地址
        if (addresses.length === 0) {
          addressData.data.is_default = 1;
          console.log("第一個地址，自動設為預設");
        }

        // 找出剩下哪一個 address 的地址類型
        const addressTypes = addresses.map((address) => {
          return address.type;
        });
        console.log("addressTypes", addressTypes);
        // 如果沒有地址類型，表示是第一個地址，設定為通訊地址
        if (addressTypes.length === 0) {
          addressData.data.type = 1;
        } else {
          // 如果有地址類型，找出剩下的地址類型
          const addressTypeSet = new Set(addressTypes);
          // 按照1,2,3 的順序去填入地址類型
          if (!addressTypeSet.has(1)) {
            addressData.data.type = 1;
          } else if (!addressTypeSet.has(2)) {
            addressData.data.type = 2;
          } else if (!addressTypeSet.has(3)) {
            addressData.data.type = 3;
          }
        }
        console.log("新增地址資料", addressData);
        addresses.push(addressData.data);
      }
      this.formData.addresses = addresses;
      this.$store.commit("basic/setSelectedAddressData", null);
      // 更新使用者資料
      this.submitForm();
    },
    /**
     * 驗證單一發票欄位（載具或愛心碼）
     * @param {object} requestData { carrier_id } 或 { love_code }
     * @param {boolean} isCarrier 是否為載具（決定阻擋訊息文字）
     * @returns {Promise<{blocked: boolean, message: string|null}>}
     */
    async validateEinvoiceField(requestData, isCarrier) {
      try {
        const response = await checkEinvoiceCode(requestData, {
          timeout: 8000,
        });
        const responseData = response?.data?.data;

        if (responseData?.msg === "Success") {
          if (responseData.is_valid === true) {
            return { blocked: false, message: null };
          }
          // 查得代碼不存在：阻擋存檔
          return {
            blocked: true,
            message: isCarrier
              ? "手機載具不存在，請確認載具號碼"
              : "查無此愛心碼，請確認號碼是否正確",
          };
        }

        // 驗證服務不可用：一律放行
        const errorCode = responseData?.error_code;
        // error_code 為 0 / null / undefined 代表沒有錯誤，不顯示警示
        if (!errorCode || isSilentPassCode(errorCode)) {
          console.log("[einvoice] 靜默放行，error_code:", errorCode);
          return { blocked: false, message: null };
        }
        const reason = getEinvoiceErrorMessage(
          errorCode,
          responseData?.err_msg ||
            responseData?.error_msg ||
            "目前無法驗證發票資訊"
        );
        return { blocked: false, message: `${reason}，請確認號碼正確。` };
      } catch (error) {
        // 網路錯誤 / timeout：放行 + 警示
        console.error("[einvoice] 驗證 API 呼叫失敗:", error);
        const errorData = getEinvoiceErrorData(error);
        const fallback = "目前無法連線驗證發票資訊";
        const reason = errorData?.error_code
          ? getEinvoiceErrorMessage(errorData.error_code, fallback)
          : fallback;
        return { blocked: false, message: `${reason}，請確認號碼正確。` };
      }
    },
    async validateForm() {
      // 檢查 email 格式
      if (
        this.formData.email &&
        !this.$validator.isValidEmail(this.formData.email)
      )
        throw "email 格式錯誤";
      // 檢查必填欄位
      if (!this.formData.mobile_phone) throw "請填寫手機門號";
      // 檢查姓名欄位
      if (!this.formData.name) throw "請填寫姓名";
      // 檢查手機號碼格式
      if (!this.$validator.isValidPhoneNumber(this.formData.mobile_phone))
        throw "手機號碼格式錯誤";
      // 公司統編驗證
      if (
        this.formData.s_vat_number &&
        !this.$validator.isVatNumberValid(this.formData.s_vat_number)
      )
        throw "統一編號格式錯誤";
      // 檢查愛心碼
      if (
        this.formData.npo_ban &&
        !this.$validator.isNpoBanValid(this.formData.npo_ban)
      )
        throw "愛心碼格式錯誤";
      // 檢查手機載具
      if (this.formData.invoice_carrier) {
        // 將手機載具轉成大寫
        this.formData.invoice_carrier =
          this.formData.invoice_carrier.toUpperCase();
        if (
          !this.$validator.isInvoiceCarrierValid(this.formData.invoice_carrier)
        )
          throw "手機載具格式錯誤";
      }

      // 格式檢查通過後，光貿店家才向後端確認代碼是否存在
      // 只驗有變動的欄位：未變動者上次儲存時已驗過
      if (!this.shouldValidateWithApi) return true;

      // 與後端一致：前後皆 strip 後比對，避免只差空白也重打驗證
      const carrier = this.formData.invoice_carrier?.trim() || "";
      const npoBan = this.formData.npo_ban?.trim() || "";
      const isCarrierChanged =
        carrier &&
        carrier !== (this.memberInfo.invoice_carrier?.trim() || "");
      const isNpoBanChanged =
        npoBan && npoBan !== (this.memberInfo.npo_ban?.trim() || "");

      if (!isCarrierChanged && !isNpoBanChanged) return true;

      // 驗證期間顯示 loading（API 需轉打外部光貿服務）
      commonUtilities.createLoading("發票資訊驗證中", "請稍候");
      const warnings = [];
      try {
        if (isCarrierChanged) {
          const result = await this.validateEinvoiceField(
            { carrier_id: carrier },
            true
          );
          // 載具：存檔時後端會再驗一次同一組載具，
          // 這裡放行也一定被擋，驗不過就直接擋下，不問使用者
          if (result.blocked) throw new Error(result.message);
          if (result.message) {
            throw new Error("目前無法驗證手機載具，請稍後再試");
          }
        }
        if (isNpoBanChanged) {
          const result = await this.validateEinvoiceField(
            { love_code: npoBan },
            false
          );
          if (result.blocked) throw new Error(result.message);
          if (result.message) warnings.push(result.message);
        }
      } catch (error) {
        commonUtilities.closeLoading();
        throw error;
      }

      // 愛心碼驗證服務不可用：後端不驗愛心碼，
      // 使用者確認後即可存檔
      if (!warnings.length) {
        commonUtilities.closeLoading();
        return true;
      }

      // 直接以確認彈窗取代 loading（Swal 同時只允許一個彈窗），
      // 不先 closeLoading，避免關閉動畫與開啟互相干擾
      const { isConfirmed } = await commonUtilities.createConfirm(
        "warning",
        "愛心碼未能驗證",
        `${warnings.join(" ")}是否仍要儲存？`,
        "仍要儲存",
        "取消"
      );
      return isConfirmed;
    },
    async submitForm() {
      // 檢查 token 是否過期
      if (!this.isLogin) {
        commonUtilities.createToast("warning", "登入狀態已過期，請重新登入");
        auth.logout();
        this.$router.push({
          path: `/${this.storeCode}`,
        });
        return;
      }
      // 檢查是否有更新資料
      if (!this.isFormDataUpdated() && !this.isAddressUpdate()) {
        commonUtilities.createToast("warning", "沒有更新資料");
        return;
      }
      // 檢查欄位
      try {
        // 回傳 false = 使用者在愛心碼警示彈窗選擇取消，不存檔也不報錯
        if (!(await this.validateForm())) return;
      } catch (error) {
        commonUtilities.createToast("error", error?.message || String(error));
        return;
      }
      // 如果生日欄位有更新 顯示確認彈窗
      if (
        this.formData["birthday"] !== null &&
        this.formData["birthday"] !== this.memberInfo["birthday"]
      ) {
        this.$refs.popup.show({
          title: `確認會員資料`,
          content: `您的生日為${moment(this.formData["birthday"])
            .local()
            .format("ll")}，會員生日輸入後即無法修改，是否確認儲存?`,
          confirmText: "確認",
          confirmEvent: this.update,
        });
      } else {
        this.update();
      }
    },
    async update() {
      try {
        console.log("submit form", this.formData);
        this.isLoading = true;
        commonUtilities.createLoading("資料更新中", "請稍後");

        // API 為部分更新：只送出實際有變動的欄位
        const updatedFields = this.getUpdatedFields();

        // 統編欄位同步：s_vat_number 有變動時，vat_number 一併同步
        if ("s_vat_number" in updatedFields) {
          const vatNumber = updatedFields.s_vat_number || null;
          updatedFields.s_vat_number = vatNumber;
          updatedFields.vat_number = vatNumber;
        }

        console.log("submit updated fields", updatedFields);
        await this.$store.dispatch("userData/updateMemberInfo", updatedFields);
        await this.initialize();
        this.isLoading = false;
        commonUtilities.createToast("success", "更新成功");
      } catch (error) {
        await this.initialize();
        this.isLoading = false;
        console.log("submit form error", error);
        commonUtilities.createToast("error", error?.message || String(error));
      }
    },
    // 取出 formData 中與 memberInfo 不同的欄位（API 為部分更新，只送異動欄位）
    getUpdatedFields() {
      // 唯讀欄位：由後端維護，不應由前端送出
      const readonlyKeys = [
        "total_points",
        "total_reward_points",
        "vip_level",
        "is_line_member",
        "store_member_uuid",
      ];
      const updatedFields = {};

      for (const key in this.formData) {
        if (readonlyKeys.includes(key)) continue;
        // addresses 為陣列，改用 isAddressUpdate() 判斷
        if (key === "addresses") continue;
        if (this.formData[key] !== this.memberInfo[key]) {
          updatedFields[key] = this.formData[key];
        }
      }

      if (this.isAddressUpdate()) {
        updatedFields.addresses = this.formData.addresses;
      }

      return updatedFields;
    },
    isFormDataUpdated() {
      // 比较 formData 和 memberInfo 的属性值
      for (const key in this.formData) {
        // 检查是否有新增的 key
        if (!(key in this.memberInfo) || this.memberInfo[key] === undefined) {
          return true;
        }
        // 檢查除了 addresses 以外的其他屬性
        if (key != "addresses" && this.formData[key] !== this.memberInfo[key]) {
          console.log(
            key,
            "has changed",
            "formData[key]",
            this.formData[key],
            "memberInfo[key]",
            this.memberInfo[key]
          );
          return true; // 如果有更新，返回 true
        }
      }

      return false; // 如果没有更新，返回 false
    },
    isAddressUpdate() {
      if (this.memberInfo.addresses == undefined) {
        return false;
      }

      // 地址數量不同，有更新
      if (this.memberInfo.addresses.length !== this.formData.addresses.length) {
        return true;
      }

      // 比較每個地址的詳細資料
      for (let i = 0; i < this.memberInfo.addresses.length; i++) {
        const originalAddress = this.memberInfo.addresses[i];
        const newAddress = this.formData.addresses[i];
        // console.log('originalAddress', originalAddress)
        // console.log('newAddress', newAddress)

        // 如果任何一個地址物件為空，表示有刪除或新增地址，有更新
        if (!originalAddress || !newAddress) {
          return true;
        }

        // 檢查每個 key 的值是否相同
        for (const key in originalAddress) {
          if (newAddress[key] != originalAddress[key]) {
            console.log(
              key,
              "has changed",
              "newAddress[key]",
              newAddress[key],
              "originalAddress[key]",
              originalAddress[key]
            );
            return true; // 地址信息不同，有更新
          }
        }

        // 檢查是否有新增的 key
        for (const key in newAddress) {
          if (!(key in originalAddress)) {
            return true; // 有新增的 key，有更新
          }
        }
      }

      // 地址信息相同，没有更新
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  width: 94%;
  padding: 0px 3% 30px;
  font-weight: 400;
}

.form_cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  margin-bottom: 15px;
  font-size: 16px;
  color: #000;
  font-weight: 400;

  input {
    width: 100%;
    height: 44px;
    border: none;
    background-color: #fff;
    font-size: 18px;
    color: #000;
    border-radius: 6px;
    padding: 0 10px;
    margin-top: 6px;
    border: 1px solid #dddddd;
  }

  ::placeholder {
    color: rgba($color: #000000, $alpha: 0.3);
  }

  select {
    width: 48%;
    height: 44px;
    border: none;
    background-color: #fff;
    font-size: 18px;
    font-family: PingFang SC;
    color: #000;
    border-radius: 6px;
    border: 1px solid #dddddd;

    /* 隐藏默认的下拉箭头 */
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    // /* 添加自定义下拉箭头样式 */
    background-image: url("@/assets/custom-arrow.png");
    background-repeat: no-repeat;
    background-position: right 10px center;
    background-size: 28px 28px;
    /* 根据需要调整箭头图像的尺寸和位置 */
    padding: 10px;
  }
}

.gender_cell {
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
  width: 100%;
  margin-top: 5px;

  .gender_button {
    width: 78px;
    height: 44px;
    background-color: #dddddd;
    color: #000;
    font-family: PingFang SC;
    font-size: 18px;
    font-weight: 400;
    border-radius: 0px;
    margin: 0 1px;
    border: none;
  }

  .gender_button.selected {
    background-color: #fbcb02;
    color: #000;
  }

  .gender_button:nth-child(1) {
    border-radius: 6px 0 0 6px;
  }

  .gender_button:nth-child(3) {
    border-radius: 0 6px 6px 0;
  }
}

.label_title {
  font-weight: 500;
  font-size: 16px;
  font-family: PingFang SC;
  margin-bottom: 5px;
}

.address {
  width: 100%;
  margin: 10px 0;
  border-bottom: 1px #aaaaaa dotted;
  color: #000;
}

.address_button {
  padding: 10px 12px;
  margin-left: 10px;
  border-radius: 30px;
  max-height: 34px;
  background-color: #dddddd;
  border: #cccccc 1px solid;
  color: #000;
  flex-shrink: 0;
  font-size: 16px;
  font-weight: 300;
}

.add_address {
  width: 100%;
  background-color: #dddddd;
  border: #cccccc 1px solid;
  color: #000;
  border-radius: 30px;
  background-color: #fff;
  font-weight: 600;
  padding: 10px 0;
  margin: 15px 0 0;
}

.address_type {
  padding: 10px;
  border-radius: 30px;
  max-height: 34px;
  background-color: #dddddd;
  color: #000;
  border: #cccccc 1px solid;
  font-size: 16px;
  pointer-events: none;
  font-weight: 300;
}

.invoce_setting {
  width: 100%;
  padding: 20px 6%;
  border-radius: 16px;
  border: 1px solid #cccccc;
  margin-bottom: 15px;
}

.swal_confirm_button {
  color: #000;
}
</style>
